var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "nonzero",
    d: "M15.919.317a.48.48 0 0 0-.438-.274H.484a.48.48 0 0 0-.438.274.47.47 0 0 0 .065.508l5.765 6.9v6.363c0 .165.086.319.228.406a.49.49 0 0 0 .47.022l3.24-1.584a.48.48 0 0 0 .269-.428l.006-4.779 5.766-6.9a.47.47 0 0 0 .064-.508M9.232 7.25a.47.47 0 0 0-.11.303l-.007 4.654-2.271 1.112V7.554a.47.47 0 0 0-.111-.304L1.51.998h12.945z"
  })));
};
export default SvgFilterIcon;